import { Connections } from '../../connections';
import { Stores } from '..';
import { UnitStore } from './unit';
import { IssuesStore } from './issues';
import { InspectionTokenStore } from './inspectionToken';
import { FileStore } from './file';
import { ReportStore } from './report';
import { HooksStore } from './hooks';

export class BackendStores {
  unit = new UnitStore(this.rootStore);

  issuesStore = new IssuesStore(this.rootStore);

  hooksStore = new HooksStore(this.rootStore);

  inspectionTokenStore = new InspectionTokenStore(this.rootStore);

  fileStore = new FileStore(this.rootStore);

  reportStore = new ReportStore(this.rootStore);

  constructor(public rootStore: Stores) {}
}
